module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "calibre1",
    attrs: {
      "id": "uZrYOkXuhPJLTlJlWhC5Bh7"
    }
  }, [_c('p', {
    staticClass: "perfect-center"
  }, [_c('span', {
    staticClass: "bold1"
  }, [_c('br', {
    staticClass: "calibre3"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "perfect-center"
  }, [_c('span', {
    staticClass: "bold1"
  }, [_vm._v("To the paratroopers of First Platoon, Charlie Troop, of the 4")]), _c('span', {
    staticClass: "bold2"
  }, [_vm._v("th")]), _c('span', {
    staticClass: "bold1"
  }, [_vm._v(" Squadron/73")]), _c('span', {
    staticClass: "bold2"
  }, [_vm._v("rd")]), _c('span', {
    staticClass: "bold1"
  }, [_vm._v(" Cavalry Regiment, 4")]), _c('span', {
    staticClass: "bold2"
  }, [_vm._v("th")]), _c('span', {
    staticClass: "bold1"
  }, [_vm._v(" Brigade Combat Team, ")])]), _vm._v(" "), _c('p', {
    staticClass: "perfect-center"
  }, [_c('span', {
    staticClass: "bold1"
  }, [_vm._v("82")]), _c('span', {
    staticClass: "bold2"
  }, [_vm._v("nd")]), _c('span', {
    staticClass: "bold1"
  }, [_vm._v(" Airborne Division, United States Army")])]), _vm._v(" "), _c('p', {
    staticClass: "perfect-center"
  }, [_c('span', {
    staticClass: "bold1"
  }, [_vm._v("for their Gallant Service in Afghanistan – 2012")])]), _vm._v(" "), _c('p', {
    staticClass: "perfect-center"
  }, [_c('span', {
    staticClass: "bold1"
  }, [_c('br', {
    staticClass: "calibre3"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "perfect-center"
  }, [_c('span', {
    staticClass: "bold1"
  }, [_vm._v("“All the Way!”")])]), _vm._v(" "), _c('p', {
    staticClass: "perfect-center"
  }, [_c('br', {
    staticClass: "calibre3"
  })]), _vm._v(" "), _c('p', {
    staticClass: "perfect-center"
  }, [_c('span', {
    staticClass: "bold1"
  }, [_vm._v("In memory of:")])]), _vm._v(" "), _c('p', {
    staticClass: "perfect-center"
  }, [_c('span', {
    staticClass: "bold1"
  }, [_vm._v("PFC MARK L KERNER, 82")]), _c('span', {
    staticClass: "bold2"
  }, [_vm._v("nd")]), _c('span', {
    staticClass: "bold1"
  }, [_vm._v(" Airborne Division")])]), _vm._v(" "), _c('p', {
    staticClass: "perfect-center"
  }, [_c('span', {
    staticClass: "bold1"
  }, [_vm._v("November 19, 1991 ~ March 1, 2015 (age 23)")])]), _vm._v(" "), _c('p', {
    staticClass: "perfect-center"
  }, [_c('span', {
    staticClass: "bold1"
  }, [_vm._v("&")])]), _vm._v(" "), _c('p', {
    staticClass: "perfect-center"
  }, [_c('span', {
    staticClass: "bold1"
  }, [_vm._v("CPL MATTHEW HANES, 82ND Airborne Division")])]), _vm._v(" "), _c('p', {
    staticClass: "perfect-center"
  }, [_c('span', {
    staticClass: "bold1"
  }, [_vm._v("June 27, 1991 ~ August 7, 2015 (age 24)")])]), _vm._v(" "), _c('p', {
    staticClass: "perfect-center"
  }, [_c('span', {
    staticClass: "bold1"
  }, [_c('br', {
    staticClass: "calibre3"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "perfect-center"
  }, [_c('span', {
    staticClass: "bold1"
  }, [_c('br', {
    staticClass: "calibre3"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "perfect-center"
  }, [_c('span', {
    staticClass: "bold1"
  }, [_vm._v("A Special Salute to:")])]), _vm._v(" "), _c('p', {
    staticClass: "perfect-center"
  }, [_c('span', {
    staticClass: "bold1"
  }, [_vm._v("1LT Don Latino and PFC Samuel Walley")])]), _vm._v(" "), _c('p', {
    staticClass: "perfect-center"
  }, [_c('span', {
    staticClass: "bold1"
  }, [_vm._v("Both Awarded the Purple Heart")])]), _vm._v(" "), _c('p', {
    staticClass: "perfect-center"
  }, [_c('span', {
    staticClass: "bold1"
  }, [_c('br', {
    staticClass: "calibre3"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "perfect-center"
  }, [_c('span', {
    staticClass: "bold1"
  }, [_vm._v("With Special Gratitude to ")])]), _vm._v(" "), _c('p', {
    staticClass: "perfect-center"
  }, [_c('span', {
    staticClass: "bold1"
  }, [_vm._v("THE UNITED AMERICAN PATRIOTS")])]), _vm._v(" "), _c('p', {
    staticClass: "perfect-center"
  }, [_c('br', {
    staticClass: "calibre3"
  })]), _vm._v(" "), _c('p', {
    staticClass: "perfect-center"
  }, [_vm._v("For supporting")]), _vm._v(" "), _c('p', {
    staticClass: "perfect-center"
  }, [_vm._v("Our nation’s warriors")]), _vm._v(" "), _c('p', {
    staticClass: "perfect-center"
  }, [_vm._v("falsely accused of “war crimes.”")]), _vm._v(" "), _c('p', {
    staticClass: "perfect-center"
  }, [_vm._v("To help American soldiers like Clint Lorance,")]), _vm._v(" "), _c('p', {
    staticClass: "perfect-center"
  }, [_vm._v("go to"), _c('br', {
    staticClass: "calibre3"
  })]), _vm._v(" "), _c('p', {
    staticClass: "perfect-center"
  }, [_c('br', {
    staticClass: "calibre3"
  })]), _vm._v(" "), _c('p', {
    staticClass: "perfect-center"
  }, [_c('a', {
    attrs: {
      "href": "http://WWW.UAP.ORG",
      "target": "_blank"
    }
  }, [_vm._v("WWW.UAP.ORG")]), _c('br', {
    staticClass: "calibre3"
  })]), _vm._v(" "), _c('p', {
    staticClass: "perfect-center"
  }, [_c('br', {
    staticClass: "calibre3"
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7191aa1a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/part0003.vue
// module id = 69
// module chunks = 0